import axios from "axios";

// PATHS
const RA_PAYMENT_TOBE_RECONCILED = '/network/ra/{id}/payments-to-be-reconciled';
const RA_PREAUTH_PAYMENT_RECONCILIATION_PREAUTH = "/network/payment/preauthorize-reconciliation";
const RA_PREAUTH_PAYMENT_RECONCILIATION_DISPOS = "/network/payment/dispositive-reconciliation ";
const RA_PREAUTH_PAYMENT_RECONCILIATION_VERIFY = "/network/payment/verify-reconciliation";
const RA_PAYMENT_RECONCILIATION_VERITY_STATUS = "/network/payment/verifypaymentstatus-reconciliation";

const raPaymentToBeReconciled: any = async ({idRA}: { idRA: string }) => {
    const path = RA_PAYMENT_TOBE_RECONCILED.replace('{id}', idRA);
    const response = await axios.get(path);
    return response.data;
}

const raPreAuthPaymentReconciliation = async (req: any) => {
    const card = req.type;
    delete req.type;

    const response = await axios.post(RA_PREAUTH_PAYMENT_RECONCILIATION_PREAUTH + `?creditCard=${card}`, req);
    return response.data;
}

const raDispositivePaymentReconciliation = async (req: any) => {
    const response = await axios.post(RA_PREAUTH_PAYMENT_RECONCILIATION_DISPOS, req);
    return response.data;
}

const raPreAuthPaymentReconciliationVerify = async (req: any) => {
    const response = await axios.post(RA_PREAUTH_PAYMENT_RECONCILIATION_VERIFY, req);
    return response.data;
}

const raPaymentReconciliationVerifyStatus = async (req: { idRA: string }) => {
    const response = await axios.post(RA_PAYMENT_RECONCILIATION_VERITY_STATUS + `?idRentalAgreement=${req.idRA}`);
    return response.data;
}

export {
    raPaymentToBeReconciled,
    raPreAuthPaymentReconciliation,
    raDispositivePaymentReconciliation,
    raPreAuthPaymentReconciliationVerify,
    raPaymentReconciliationVerifyStatus
}